import $ = require("jquery");
import _ = require("underscore");
import Base = require("./base-command");

const defaults = {
  className: "ol-control bottom-1 left-1 growl",
  "remove-delay": "5"
};

class Command extends Base<{ in?: any; out?: { message: string } }> {
  static about = `
Adds a growl element to the bottom-right of the window.

Usage Example:

    <EVENT about="Add &quot;growl&quot; handler to support notifying user when no results are found" event="growl" id="growl" mid="app/commands/growl">
    <OPTIONS>
        <Values about="Clear message after 5 seconds" id="remove-delay" value="5" />
    </OPTIONS>
    </EVENT>

    `;

  static options = _.defaults(
    {
      className: {
        about: "The css class name to assign to the main element",
        default: defaults.className
      },
      "remove-delay": {
        about:
          "number of seconds to wait before auto-dismissing the message area",
        default: defaults["remove-delay"]
      }
    },
    Base.options
  );

  execute(args = this.args) {
    let options = _.defaults(this.options, defaults);
    let msg = this.findOption("message");
    msg && this.growl(msg);
  }

  private growl(message: string) {
    if (typeof message === "undefined") return;
    let parent = $(".ol-overlaycontainer-stopevent");
    let childCss = this.options.className;
    let growlContainer = $(`.${childCss.split(" ").join(".")}`);
    if (!growlContainer.length) {
      growlContainer = $("<div></div>")
        .addClass(childCss)
        .appendTo(parent);
    }

    let msgNode = $(`<div>${message}</div>`);
    $(msgNode).click(() => msgNode.remove());
    growlContainer.append(msgNode);

    let delay = 1000 * parseInt(this.options["remove-delay"] || "10");
    setTimeout(() => msgNode.remove(), delay);

    this.trigger();
  }
}

export = Command;
